(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icons-and-text-row"] && !Shopify.designMode) return;
  try {
    
  /* Your scripts go here */

  } catch(e) { console.error(e); }
})();
})();
